import { TuiIconTdsIllustrationsCommonStopwachLight } from '@tui-react/proprietary-icons';
import { formatDuration, intervalToDuration } from 'date-fns';
import ru from 'date-fns/locale/ru';
import React, { FC } from 'react';
import { FormattedMessage as Message } from 'react-intl';
import intl from '../../locale';
import { NewOverlay } from '../NewOverlay';

interface NewGlobalTimerOverlayProps {
  onStartGlobalTimer: () => void;
  timerStrict?: boolean;
  timeDurationSec?: number;
  onClose: () => void;
  isWebview: boolean;
}

export const NewGlobalTimerOverlay: FC<NewGlobalTimerOverlayProps> = ({
  onStartGlobalTimer,
  timerStrict,
  timeDurationSec = 0,
  onClose,
  isWebview,
}) => {
  const duration = intervalToDuration({ start: 0, end: timeDurationSec * 1000 });

  const formattedTime = formatDuration(duration, { locale: ru });

  return (
    <NewOverlay
      isWebview={isWebview}
      icon={<TuiIconTdsIllustrationsCommonStopwachLight iconSize={160} />}
      title={
        <>
          <Message id={'PageTimer.PlugTitle1'} />
          <br />
          <Message id={'PageTimer.PlugTitle2'} values={{ formattedTime }} />
          <br />
          <Message id={'PageTimer.PlugTitle3'} />
        </>
      }
      description={
        <Message
          id={'PageTimer.PlugDescription'}
          values={{
            timerStrict: timerStrict
              ? intl.formatMessage({ id: 'PageTimer.StrictDescription' })
              : intl.formatMessage({ id: 'PageTimer.NonStrictDescription' }),
          }}
        />
      }
      buttonText={intl.formatMessage({ id: 'System.StartPoll' })}
      onClick={onStartGlobalTimer}
      onClose={onClose}
    />
  );
};
